//@ts-nocheck
import * as React from "react";
import { InputProps } from "../@types/input";

export default function Input(props: InputProps) {
  const {
    label,
    onChange,
    getValue,
    wrapperClassName,
    placeholderTextColor,
    ...other
  } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.FormEvent<HTMLInputElement>
  ) => {
    const val = e.currentTarget?.value;
    getValue?.(val, e);
    onChange?.(e);
  };

  return (
    <React.Fragment>
      {props.type !== "textarea" && (
        <input onChange={handleChange} {...other} />
      )}
      {props.type === "textarea" && (
        <textarea onChange={handleChange} {...other} />
      )}
    </React.Fragment>
  );
}
